var map = {
	"./images/bitJob.png": 1842
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1841;


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners ^.*\/bitJob\.png$
// module id = 1841
// module chunks = 146